exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "footer.main-footer{padding:30px 0 0;overflow-x:hidden;background:#5989e5;color:#fff}", "", {"version":3,"sources":["/Users/jaylogelin/Documents/mineables/site/src/components/Footer.vue"],"names":[],"mappings":"AACA,mBACI,iBAAkB,AAClB,kBAAmB,AACnB,mBAAoB,AACpB,UAAY,CACf","file":"Footer.vue","sourcesContent":["\nfooter.main-footer {\n    padding: 30px 0 0;\n    overflow-x: hidden;\n    background: #5989e5;\n    color: #fff;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b786a63c","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Footer.vue
// module id = aMMQ
// module chunks = 10